
<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-input placeholder="enter master stock code" class="w-full" label="Master Stock Code"
          v-model="masterStockCode" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button id="btnSave" @click="submitMasterStockCode" class="mr-3 mb-2">Submit</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="masterStockCode = '';">Reset</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { axiosMixin } from "@/mixin/axiosMixin.js";
export default {
  mixins: [axiosMixin],
  data() {
    return {
      masterStockCode: '',
      disableSubmitBtn: false,
      endPoint: "masterstockcodes",
      operation: "add",
      masterCodeId: "",

    }
  }, 
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#btnSave",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#btnSave > .con-vs-loading");
    },
    submitMasterStockCode() {
      this.startLoading();
      console.log("endPoint:", this.endPoint);
      this.inputParams = { name: this.masterStockCode }
      this.aronPostPut(
        this.endPoint,
        this.operation,
        this.inputParams,
        this.masterCodeId
      )
        .then(response => {
          //this.$router.push("/" + this.getCallBack).catch(() => {});

          if (this.operation == "add") {
            this.$emit("addnew", {
              response: response.data,
              view: "list"
            });
          } else {
            this.$emit("updateRow", {
              response: response.data,
              view: "view"
            });
          }
          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        });
    }
  }
}
</script>
